import React, { useContext, useEffect, useState } from "react"
import ServiceCardPreview from "./ServiceCardPreview"
import useLoading from "../../hooks/useLoading"
import useScrollToTop from "../../hooks/useScrollToTop"
import { Link } from "react-router-dom"
import { ServiceRequests } from "../../api/app.service"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

interface Props {
  setInviteToService: any
  setConfirmServiceInvite: any
}

const InviteToService: React.FC<Props> = ({
  setInviteToService,
  setConfirmServiceInvite,
}) => {
  const [services, setServices] = useState<any[]>([])
  const { user } = useContext(UserCtx)
  const { startLoading, stopLoading } = useLoading()
  const { toast } = useToast()

  const getServices = () => {
    if (user) {
      startLoading()
      ServiceRequests.getServiceListClient({
        profile_id: user.activeProfileId,
        profile_type: user.activeProfile,
      })
        .then((data) => {
          setServices(data.service_list)
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
        })
        .finally(() => {
          stopLoading()
        })
    }
  }

  useEffect(() => {
    getServices()
  }, [])

  useScrollToTop()

  const goToConfirm = (service: any) => {
    setConfirmServiceInvite(service)
    setInviteToService(false)
  }

  return (
    <div className="px-[20px] md:px-0 w-full md:w-[1080px] mx-auto flex flex-col">
      <h1 className="hidden md:block font-bold text-[36px] mb-[32px]">
        Invite to Service
      </h1>
      <div className="flex flex-wrap justify-center md:justify-start gap-[24px]">
        {services.filter(
          (service) => service.service_details.status === "active"
        ).length === 0 && (
          <div className="w-full font-bold flex flex-col justify-center text-center items-center pt-[40px]">
            <p className="mb-[24px] max-w-xl">
              You currently do not have any active services. Please create an
              active service before inviting a contact to participate.
            </p>
            <Link
              to="/coach/services"
              className="btn-primary btn-blue bg-blurple rounded-md w-fit"
            >
              Go To My Services
            </Link>
          </div>
        )}
        {services
          ?.filter((service) => service.service_details.status === "active")
          .map((service, idx) => (
            <div key={idx} className="w-full md:w-[48%]">
              <ServiceCardPreview
                service={service}
                buttonText="Choose Service"
                buttonCallback={() => goToConfirm(service)}
                secondaryButtonCallback={null}
              />
            </div>
          ))}
      </div>
    </div>
  )
}

export default InviteToService
